// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__2rttr","icon":"SortAdornment_icon__3UTyz","up":"SortAdornment_up__3S2BF","down":"SortAdornment_down__1dLfe","active":"SortAdornment_active__3UBI7"};